import type {MutationHookOptions} from '@apollo/client';
import {useMutation as useMutationOrig} from '@apollo/client';
import type {DocumentNode, ExecutionResult} from 'graphql';

export const useMutation = <
  TData extends Record<string, any> = any,
  TVariables = Record<string, any>,
>(
  query: DocumentNode,
  params?: MutationHookOptions<TData, TVariables>,
) => useMutationOrig<TData, TVariables>(query, params)[0];

export type MutFun<
  TData extends Record<string, any> = any,
  TVariables = Record<string, any>,
> = (
  params?: MutationHookOptions<TData, TVariables>,
) => Promise<ExecutionResult<TData>>;
